/* global localStorage, SGWebStorage, shopSettings */
import DebugConsole from '../../common/debug/debug-console';
/**
 * Manages clientInformation which is sent to WebStore from the
 * app start.
 * Something is saving this information also to a localStorage, so we have
 * two sources of truth here.
 */
class ClientInformation {
  constructor(_SGWebStorage) {
    this.SGWebStorage = _SGWebStorage || SGWebStorage;
    this.logger = new DebugConsole();
    this.key = 'clientInformation';
    /**
     * We only need to fetch the data once to the memory.
     * This promise will always give you correct information
     * without executing the resolver all over again.
     */
    this.fetchPromise =
      this.fetch()
        .catch(err => this.logger.error('Cannot get clientInformation.', err));
  }

  /**
   * Fetches the data from environment.
   * @return {Promise}
   */
  fetch() {
    return new Promise((resolve, reject) => {
      this.fetchFromLocalStorage()
        .then(clientInformation => resolve(clientInformation))
        .catch((err) => {
          if (err) {
            reject(err);
            return;
          }

          this.fetchFromWebStorage()
            .then((clientInformation => resolve(clientInformation)))
            .catch((e) => {
              reject(e);
            });
        });
    });
  }

  /**
   * Fetches the data from localStorage.
   * If there's nothing there, rejects.
   * @return {Promise}
   */
  fetchFromLocalStorage() {
    return new Promise((resolve, reject) => {
      let clientInformation;
      try {
        clientInformation = JSON.parse(localStorage.getItem(this.key));
      } catch (err) {
      }

      return clientInformation ?
        resolve(clientInformation)
        : reject();
    });
  }

  /**
   * Fetches the daa from WebStorage.
   * If there's nothing there, rejects.
   * @return {Promise}
   */
  fetchFromWebStorage() {
    return new Promise((resolve, reject) => {
      this.SGWebStorage.Get(this.key, (clientInformation) => {
        return clientInformation ?
          resolve(clientInformation)
          : reject();
      });
    });
  }

  /**
   * Resolves if current app has amazonPay native sdk
   * compiled.
   * @return {Promise}
   */
  hasAmazonPay() {
    return new Promise((resolve, reject) => {
      this.fetchPromise
        .then(
          clientInfo => (
            (typeof clientInfo === 'object'
            && clientInfo.hasOwnProperty('supportedPaymentServices')
            && clientInfo.supportedPaymentServices.hasOwnProperty('amazon'))
              ? resolve() : reject()
          )
        );
    });
  }

  /**
   * Checks if messaging service is on the supported services list.
   * @param {string} name name of the service (e.x. intercom)
   * @return {Promise}
   */
  hasMessagingService(name) {
    return new Promise((resolve, reject) => {
      this.fetchPromise
        .then(clientInfo => (
            (typeof clientInfo === 'object'
            && clientInfo.hasOwnProperty('supportedInAppMessagingServices')
            && clientInfo.supportedInAppMessagingServices.indexOf(name) > -1)
              ? resolve() : reject()
        ));
    });
  }

  isCssCheckSupported() {
    return new Promise((resolve, reject) => {
      this.fetchPromise
        .then((clientInfo) => {
          if (typeof clientInfo === 'object'
            && clientInfo.hasOwnProperty('device')
            && clientInfo.device.hasOwnProperty('os')
          ) {
            const hasFeature = typeof shopSettings !== 'undefined' && shopSettings.hasWebLogging;
            const deviceOs = clientInfo.device.os.ver.match(/(\d+)\./);
            /*
            CSSBugLogger.checkIfCssLoaded() will always fail for ios 11
            because el.sheet.cssRules is always empty - CSSStyleSheet object
            is created but rules are not set
            */
            const osOk = clientInfo.device.os.platform === 'android' ||
              (clientInfo.device.os.platform === 'ios' && deviceOs !== null && deviceOs[1] < 11);

            if (osOk && hasFeature) {
              return resolve();
            }
          }

          return reject();
        });
    });
  }
}

export default ClientInformation;



// WEBPACK FOOTER //
// ./Library/1.0/app/client-information/ClientInformation.js